import { SimpleBanner } from '@/components/Banners/SimpleBanner'
import { Button } from '@/components/Button/Button'
import modalService from '@/services/modal.service'
import React, { useEffect } from 'react'
import { ReactComponent as CrossIcon } from '@/assets/icons/editor/cross-times-chip.svg'

import './UpgradeSubscriptionModal.scoped.sass'
import commonsService from '@/services/commons.service'
import { saveItemInLocalStorage } from '@/core/localstorage'

export function UpgradeSubscriptionModal () {
  useEffect(async () => {
    // Call here API for getting cancelling subscription data
  }, [])

  /* async function cancelSubscriptionWithType (type) {
    store.commit('SUBSCRIPTION:CHANGED')
  } */

  function upgradeSubscriptionThroughOnboarding () {
    modalService.close()
    saveItemInLocalStorage('couponCode', 'PreBetaDiscount60')
    commonsService.goToPage('/auth/signup/domain-selection?upgrade=true')
  }
  
  return (<div className='cancel-subscription-modal'>
    <div className='cancel-subscription-header'>
      <div>
        <p className='main-phrase'>Let's upgrade your subscription 🚀</p>
        <p className='main-subphrase'>It will take just a moment!</p>
      </div>
      <div className='close-icon' onClick={() => modalService.close()}><CrossIcon/></div>
    </div>
    <div className='cancel-subscription-content'>
      By upgrading your subscription, you'll enjoy the following benefits:
      <p>
        <SimpleBanner type='info'>
          <p>
            <div className='font-medium'><b>Have your own domain:</b></div>
            <div>Choose the domain that better suits your needs and send / receive mails from addresses like <b>friends@mydomain.com</b> or <b>provider1@mydomain.com</b>.</div>
            <div className="text-xs mt-xs">
              <i>
                ( Don't worry, addresses created during your trial domain will still work and the boxes you have will continue being fully operative for both domains )
              </i>
              <span style={{ fontSize: '20px', marginLeft: '4px' }}>😉</span>
            </div>
          </p>
          <p>
            <div className='font-medium'><b>Subscription discount:</b></div>
            <div>Enjoy a <b>40% off in your subscription</b> during all your Boxes journey.</div>
          </p>
          <p>
            <div className='font-medium'><b>Your data, your rules:</b></div>
            <div>
              If at <b>any given moment</b>, you decide to cancel your subscription, we will send you a message with a link where you can download your data and attachments to your computer.
            </div>
          </p>
        </SimpleBanner>
      </p>
    </div>
    <div className='cancel-actions'>
      <div>
        <Button content="Let's Go!" type='primary' size='large' click={upgradeSubscriptionThroughOnboarding}/>
      </div>
    </div>
    
  </div>)
}
